export default "__VITE_PUBLIC_ASSET__79e48b2a__"